import { SearchOutlined, CloseOutlined } from "@ant-design/icons";
import { TProfileEdit } from "@utils/Interfaces";
import { Input, Button } from "antd";
import { useState } from "react";

const LanguageEdit: React.FC<TProfileEdit> = ({ data, handleChangeValue }) => {
  const [language, setLanguage] = useState("");

  const handleAddLanguage = () => {
    if (language == "") {
      return;
    }
    const langArray: string[] = [...(data.languages || [])];
    langArray.push(language);
    handleChangeValue(langArray, "languages");
    setLanguage("");
  };

  const removeLanguage = (indexToRemove: any) => {
    const langArray: string[] = [...(data.languages || [])];
    const updatedItems = langArray.filter(
      (_, index) => index !== indexToRemove
    );
    handleChangeValue(updatedItems, "languages");
  };

  return (
    <div className="SkillEdit">
      <div className="d-flex gap-2 align-items-center">
        <Input
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
          onKeyDown={(e) => {
            if (e.key == "Enter") {
              handleAddLanguage();
            }
          }}
          size="large"
          prefix={<SearchOutlined />}
        />
        <Button className="add-btn" size="large" onClick={handleAddLanguage}>
          Add
        </Button>
      </div>
      <div className="lang-group">
        {data.languages?.map((item, index) => {
          return (
            <div
              className="lang-item"
              onClick={() => removeLanguage(index)}
              key={index}
            >
              <span>{item}</span>
              <CloseOutlined style={{ fontSize: 10 }} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LanguageEdit
